
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, NgZone } from '@angular/core';
import { ProxyCmp, initOutputs } from '../lib';
import type { JSX, Components } from '@vime/core/dist/types';

import { 
  VmAudio,
  VmFile 
} from '@vime/core';

import { define } from '../lib';
  

const AudioInputs: string[] = [
  'willAttach',
  'crossOrigin',
  'preload',
  'disableRemotePlayback',
  'mediaTitle',
];

const AudioMethods: string[] = [
  'getAdapter',
];

const AudioOutputs: string[] = [
  
];

export type Emitter<T extends ((...args: any[]) => any) | undefined> = EventEmitter<Parameters<Exclude<T, undefined>>[0]>;

export declare interface Audio extends Components.VmAudio {}

@ProxyCmp({
  inputs: AudioInputs,
  methods: AudioMethods,
})
@Component({
  selector: 'vm-audio',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: AudioInputs,
  outputs: AudioOutputs,
})
export class Audio {
  protected el: HTMLElement;

  

  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    define('vm-audio', VmAudio);
    define('vm-file', VmFile);
    c.detach();
    this.el = r.nativeElement;
    initOutputs(this, [])
  }
}
  